import { Status } from '@aposphaere/core-kit'

export function isStatusCancelled(status: Status): boolean {
  return ['Absage<12Std', 'Abgesagt'].includes(status.label_short)
}

export function getCancelledStatusIds(statuses: Status[]): number[] {
  return statuses.filter((status) => isStatusCancelled(status)).map(({ id }) => id)
}
